import { Controller } from "@hotwired/stimulus"

// UI-SPEC §Layout: "FLASH BANNER (conditional, auto-dismiss 4s, full-width)".
// Hooked via data-controller="flash" in shared/_flash.html.erb. Removes the
// element from the DOM after `delayValue` ms with a brief opacity transition,
// so operators do not have to manually dismiss every notice/alert.
//
// Auto-registered via the controllers/index.js esbuild glob (do NOT edit index.js).
//
// Value:
//   delay — auto-dismiss timeout in ms (default 4000 per UI-SPEC)
export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } }

  connect() {
    this.timer = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  dismiss() {
    if (!this.element || !this.element.isConnected) return
    this.element.style.transition = "opacity 200ms ease-out"
    this.element.style.opacity = "0"
    setTimeout(() => {
      if (this.element && this.element.isConnected) {
        this.element.remove()
      }
    }, 200)
  }
}
